import { useState } from "react";
import { Link } from "react-router-dom";
import { loginFunc } from "../api";
import { Row, Button, Form, Label, Col, Input, Container } from "reactstrap";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await loginFunc(username, password);
            window.location.href = "/";  // Redirect after login
        } catch (error) {
            console.error("Login failed", error);
        }
    };

    return (
        <Container className="contain login-page auth-page d-flex justify-content-center align-items-center vh-100">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={8} lg={5}>
                    <Form className="auth-panel">
                        <Row className="g-3 flex-column text-center">
                            <Col>
                                <img
                                    src="/icon-lfx-192.svg"
                                    alt="Limitless FX"
                                    className="login-app-icon"
                                />
                            </Col>
                            <Col>
                                <Label className="visually-hidden" for="Username">
                                    Email
                                </Label>
                                <Input
                                    id="Username"
                                    name="Username"
                                    placeholder="Email"
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </Col>
                            <Col>
                                <Label className="visually-hidden" for="Password">
                                    Password
                                </Label>
                                <Input
                                    id="Password"
                                    name="Password"
                                    placeholder="Password"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Col>
                            <Col>
                                <Button
                                    type="submit"
                                    onClick={handleLogin}
                                    className="brand-action-button"
                                >
                                    Login
                                </Button>
                            </Col>
                            <Col>
                                <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>

       
    );
};

export default Login;
